export default __webpack_public_path__ + "static/borrower_img_mobile-e7952e1e3e7416299a2ad2de704efee3.png";